/**
 *  Initialize jsModule
 */

var _moduleProductsFilter = (function () {
  const productFilterElement = document.getElementById('product-filter');

  if (!productFilterElement) {
    return;
  }

  // Setup API URL
  let productsDefaultRestUrl = window.location.origin;
  productsDefaultRestUrl += '/wp-json/product-filter/v2/params?';

  // Check for primary taxonomy and tax term id setup in DOM element attributes
  // then update API URL with corresponding query params
  const primaryTaxonomy = productFilterElement.dataset.primaryTaxonomy;
  const primaryTermID   = productFilterElement.dataset.primaryTermId;
  if (primaryTaxonomy && primaryTermID) {
    productsDefaultRestUrl += '&primary_taxonomy=' + primaryTaxonomy;
    productsDefaultRestUrl += '&product_' + primaryTaxonomy + '=' + primaryTermID;
  }

  // Check for secondary taxonomy as above
  const secondaryTaxonomy = productFilterElement.dataset.secondaryTaxonomy;
  const secondaryTermID   = productFilterElement.dataset.secondaryTermId;
  if (secondaryTaxonomy && secondaryTermID) {
    productsDefaultRestUrl += '&secondary_taxonomy=' + secondaryTaxonomy;
    productsDefaultRestUrl += '&product_' + secondaryTaxonomy + '=' + secondaryTermID;
  }

  /* eslint-disable no-new */
  new Vue({
    el: '#product-filter',
    data: {
      dropdownFilter: {
        options: [
          {
            text: 'Featured Only',
            restSort: '&meta_key=featured&orderby=meta_value&order=asc'
          },
          {
            text: 'Title A-Z',
            restSort: '&orderby=title&order=asc'
          },
          {
            text: 'Title Z-A',
            restSort: '&orderby=title&order=desc'
          },
          {
            text: 'Newer Years First',
            restSort: '&meta_key=years&orderby=meta_value_num&order=desc'
          },
          {
            text: 'Older Years First',
            restSort: '&meta_key=years&orderby=meta_value_num&order=asc'
          }
        ],
        selected: {
          text: 'Title A-Z',
          restSort: '&orderby=title&order=asc'
        }
      },
      isLoading: false,                     // DISPLAY: loading panel
      displayedProductAmount: 'Loading...', // DISPLAY: current product filter amount string
      totalPages: 1,                        // from REST: total pages
      currentPage: 1,                       // current page for pagination and to REST query
      products: [],                         // from REST: products
      productLayoutList: false,             // LAYOUT: (false) show tiles (true) show table list
      taxonomies: [],                       // from WP: all taxonomies and used terms.
      restTaxQueryParams: [],               // to REST: taxonomies and terms in query string format
      featured: false
    },
    watch: {
      'dropdownFilter.selected.restSort'() {
        this.resetPageAndFetchData();
      },
      'dropdownFilter.selected.text'() {
        this.featured = this.dropdownFilter.selected.text === 'Featured Only' ? true : false;
      },
      currentPage() {
        this.fetchData();
        document.getElementById('product-filter').scrollIntoView(true);
      },
      restTaxQueryParams() {
        this.resetPageAndFetchData();
      }
    },
    methods: {
      fetchData(initializeTaxonomies = false) {
        this.displayedProductAmount = 'Loading...';
        this.isLoading = true;

        let pagedAPIFetch = productsDefaultRestUrl + '&per_page=15&page=' + this.currentPage;
        pagedAPIFetch += this.dropdownFilter.selected.restSort;
        pagedAPIFetch += this.restTaxQueryParams.join('');

        axios
          .get(pagedAPIFetch)
          .then(response => {
            this.products = response.data.products;
            this.totalPages = response.data.pages;
            this.displayedProductAmount = response.data.total_matching_products + ' Results';

            // Get tax and terms from WP on first page load.
            if (initializeTaxonomies) {
              this.taxonomies = response.data.taxonomies;
            } else {
              this.updateTaxonomyTermCounts(response.data.taxonomies);
            }
            this.isLoading = false;
          })
          .catch(reason => {
            console.log('Failed to fetch products: ' + reason);
            this.displayedProductAmount = 'No matching products';
            this.isLoading = false;
          });
      },
      updateTaxonomyTermCounts(newTaxonomyList) {
        // Updates this.taxonomies term counts against fetched taxonomy data
        Object.keys(this.taxonomies).forEach(taxonomy => {
          this.taxonomies[taxonomy].allTermsCount = newTaxonomyList[taxonomy].allTermsCount;
          this.taxonomies[taxonomy].totalParentTerms = newTaxonomyList[taxonomy].totalParentTerms;
          Object.keys(this.taxonomies[taxonomy].terms).forEach(term => {
            const taxonomyTermObject = this.taxonomies[taxonomy].terms[term];
            // Update root level counts
            if (newTaxonomyList[taxonomy]
                && newTaxonomyList[taxonomy].terms[term]) {
              taxonomyTermObject.count = newTaxonomyList[taxonomy].terms[term].count;
            } else {
              taxonomyTermObject.count = 0;
            }
            // Update child level counts for this term's iteration
            Object.keys(taxonomyTermObject.children).forEach(termChild => {
              if (newTaxonomyList[taxonomy]
                && newTaxonomyList[taxonomy].terms[term]
                && newTaxonomyList[taxonomy].terms[term].children[termChild]) {
                taxonomyTermObject.children[termChild].count
                = newTaxonomyList[taxonomy].terms[term].children[termChild].count;
              } else {
                taxonomyTermObject.children[termChild].count = 0;
              }
            });
          });
        });
      },
      resetPageAndFetchData() {
        if (this.currentPage === 1) {
          this.fetchData();
        } else {
          this.currentPage = 1;
        }
      },
      updateTaxQueries(oldQueryString, newQueryString) {
        const currentQueryString = this.restTaxQueryParams.indexOf(oldQueryString);
        if (currentQueryString > -1 || newQueryString.length === 0) {
          this.restTaxQueryParams.splice(currentQueryString, 1);
        }
        if (newQueryString.length > 0) {
          this.restTaxQueryParams.push(newQueryString);
        }
      },
      resetFilters() {
        this.restTaxQueryParams = [];
      }
    },
    created() {
      this.fetchData(true);
    },
    mounted() {
      // Listen for pagination change from component
      this.$root.$on('paginationChanged', (newPage) => {
        this.currentPage = newPage;
      });
    }
  });


  // Single taxonomy filter component
  Vue.component('tax-term-list', {
    props: {
      name: String,
      taxonomy: Object,
      resetTerms: Boolean
    },
    data() {
      return {
        menuOpen: true,       // State of whether tax menu is open
        showMoreOpen: false,  // State of 'more' button and additional terms visibility
        moreTerms: 6,         // Number of terms to show before "more" appears
        selectedTaxTerms: [], // This taxonomy's currently selected terms used with API query
        oldQueryString: '',   // Old q string to compare with in parent
        newQueryString: '',   // New q string to compare with in parent
        taxonomyList: []      // Array version of taxonomy prop obj for sortability
      };
    },
    methods: {
      updateSelectedTaxTerms(termData) {
        // Handle adding ids to selectedTaxTerms
        Object.values(termData.activeTermIDs).forEach(termID => {
          if (!this.selectedTaxTerms.includes(termID)) {
            this.selectedTaxTerms.push(termID);
          }
        });
        // Handle removing ids from selectedTaxTerms
        Object.values(termData.removeTermIDs).forEach(termID => {
          const termPosition = this.selectedTaxTerms.indexOf(termID);
          this.selectedTaxTerms.splice(termPosition, 1);
        });
        // Update query string
        if (this.selectedTaxTerms.length > 0) {
          this.newQueryString = '&product_' + this.name + '=' + this.selectedTaxTerms.join(',');
        } else {
          this.newQueryString = '';
        }
        this.$emit('tax-filter-updated', this.oldQueryString, this.newQueryString);
        this.oldQueryString = this.newQueryString;
      }
    },
    watch: {
      resetTerms() {
        if (this.resetTerms) {
          // Reset selectedTaxTerms list
          this.oldQueryString = '';
          this.selectedTaxTerms = [];
        }
      }
    },
    created() {
      // Create terms list array from object for sorting
      Object.values(this.taxonomy.terms).forEach((value) => {
        this.taxonomyList.push(value);
      });
      // Order the taxonomy terms alphabetically
      let comparison = 0;
      this.taxonomyList.sort((a, b) => {
        if (a.slug > b.slug) {
          comparison = 1;
        } else if (a.slug < b.slug) {
          comparison = -1;
        }
        return comparison;
      });
    },
    template: `
      <div v-if="this.taxonomy.allTermsCount > 0" class="col-xs-12 col-sm-4 col-md-12">
        <div class="taxonomy" :class="{'taxonomy--open': menuOpen === true}">
          <div class="taxonomy__name" @click="menuOpen = !menuOpen">
            <span v-text="this.taxonomy.object.labels.singular_name"></span> <span class="toggle glyphicon glyphicon-plus"></span>
          </div>
          <ul class="taxonomy__terms-list">
            <tax-term-list-item
              v-for="(term, index) in taxonomyList"
              :term="term"
              :reset-term="resetTerms"
              :visible="index < moreTerms || showMoreOpen"
              @term-filter-updated="updateSelectedTaxTerms">{{ taxonomyList }}
            </tax-term-list-item>
          </ul>
          <a class="taxonomy__more" 
             v-show="this.taxonomy.totalParentTerms > moreTerms && menuOpen"
             @click="showMoreOpen = !showMoreOpen">
            <span v-if="!showMoreOpen">More</span>
            <span v-if="showMoreOpen">Less</span>
          </a>
        </div>
      </div>
    `
  });


  // Taxonomy filter section list item component
  Vue.component('tax-term-list-item', {
    props: {
      term: Object,
      resetTerm: Boolean,
      visible: Boolean
    },
    data() {
      return {
        mainFilterActive: false,
        componentTerm: this.term,
        allTermIDs: [],
        allTermChildIDs: [],
        activeChildTermIDs: [],
        flaggedIDsForRemoval: [],
        childTermsList: []
      };
    },
    created() {
      Object.values(this.componentTerm.children).forEach(child => {
        this.$set(child, 'active', false);
        this.allTermChildIDs.push(child.term_id);
      });
      this.allTermIDs.concat(this.allTermChildIDs).push(this.term.term_id);
      // Create child terms list array from object for sorting
      Object.values(this.term.children).forEach((value) => {
        this.childTermsList.push(value);
      });
      // Order the terms alphabetically
      let comparison = 0;
      this.childTermsList.sort((a, b) => {
        if (a.slug > b.slug) {
          comparison = 1;
        } else if (a.slug < b.slug) {
          comparison = -1;
        }
        return comparison;
      });
    },
    methods: {
      updateFilter() {
        this.mainFilterActive = !this.mainFilterActive;
        this.$emit('term-filter-updated', {
          'activeTermIDs': this.mainFilterActive ? [this.term.term_id] : [],
          'removeTermIDs': this.mainFilterActive ? this.activeChildTermIDs : [this.term.term_id]
        });
        this.deactivateChildren();
      },
      updateChildFilter(childTermObject) {
        if (this.mainFilterActive === true) {
          this.mainFilterActive = false;
          this.flaggedIDsForRemoval.push(this.term.term_id);
        }
        childTermObject.active = !childTermObject.active;
        if (!this.activeChildTermIDs.includes(childTermObject.term_id)) {
          this.activeChildTermIDs.push(childTermObject.term_id);
        } else {
          const childPosition = this.activeChildTermIDs.indexOf(childTermObject.term_id);
          this.activeChildTermIDs.splice(childPosition, 1);
        }
        if (childTermObject.active === false) {
          this.flaggedIDsForRemoval.push(childTermObject.term_id);
        }
        this.$emit('term-filter-updated', {
          'activeTermIDs': this.activeChildTermIDs,
          'removeTermIDs': this.flaggedIDsForRemoval
        });
        this.flaggedIDsForRemoval = [];
      },
      deactivateChildren() {
        Object.values(this.componentTerm.children).forEach(child => {
          child.active = false;
          this.activeChildTermIDs = [];
        });
      }
    },
    watch: {
      resetTerm() {
        if (this.resetTerm) {
          this.mainFilterActive = false;
          this.deactivateChildren();
        }
      }
    },
    computed: {
      mainTermVisible() {
        return this.visible && this.term.count > 0;
      },
      childListVisible() {
        return this.term.childrenTermCount > 0
               && (this.mainFilterActive || this.activeChildTermIDs.length > 0);
      }
    },
    template: `
      <li v-if="mainTermVisible"
        :data-id="term.term_id"
        :class="{selected: mainFilterActive}">
        <span @click="updateFilter">{{ term.name }}</span>
        <ul v-if="childListVisible">
          <li @click="updateChildFilter(childTerm)"
            v-for="(childTerm, index) in childTermsList"
            v-if="childTerm.count > 0"
            :data-id="childTerm.term_id"
            :class="{selected: childTerm.active}">
            {{ childTerm.name }}
          </li>
        </ul>
      </li>
      `
  });


  // Product component
  Vue.component('product-item', {
    props: {
      product: Object
    },
    computed: {
      productImage() {
        return this.product.image.has_image ? this.product.image.sizes.medium : '';
      },
      productLanguages() {
        return this.product.additional_data.languages.map(lang => lang.name).join(', ');
      }
    },
    template: `
      <div class="filter-products__product col-xxs-12 col-xs-6 col-sm-4 col-lg-2-4" 
           :data-title="product.title">
        <a class="filter-products__image" 
           v-bind:href="product.link" 
           v-bind:alt="product.image.alt" 
           v-bind:style="{ 'background-image': 'url(' +  productImage + ')' }"></a>
        <div class="filter-products__title">
          <a v-bind:href="product.link" v-text="product.title"></a>
        </div>
        <div class="filter-products__language"
             v-text="productLanguages"></div>
        <div class="filter-products__years"
             v-text="product.additional_data.years"></div>
        <div class="filter-products__country"
             v-text="product.additional_data.countries"></div>    
      </div>
      `
  });


  // Pagination button component
  Vue.component('pagination-link', {
    props: {
      page: Number,
      currentPage: Number
    },
    methods: {
      checkForPageChange(page, currentPage) {
        if (page !== currentPage) {
          this.$root.$emit('paginationChanged', page);
        }
      }
    },
    template: `
      <a :class="{'current': (page === currentPage)}"
         @click.prevent="checkForPageChange(page, currentPage)"
         v-text="page">
      </a>
      `
  });

  Vue.config.devtools = true;

  var pub = { }; // public facing functions

  pub.init = function () { };

  return pub;

}());
